import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Chart.styl';

/**
 * An element to hide/wrap the SVG.
 *
 * @param svgDimensions
 * @param children
 * @returns Section/SVG in order to nest child chart elements inside
 *
 * @deprecated - use Chart from src/charts instead
 */
export default class Chart extends React.Component {
  render() {
    const {className, margins, svgDimensions, children, gradients, placeholder, bordered, defs} =
      this.props;

    return (
      <section className={classNames('custom-chart', className)}>
        {placeholder}
        <svg
          viewBox={'0 0 ' + svgDimensions.width + ' ' + svgDimensions.height}
          ref={n => (this.svg = n)}>
          <defs>
            {gradients &&
              gradients.map(g => (
                <Gradient
                  id={g.id}
                  key={g.id}
                  direction={g.direction}
                  startOpacity={g.startOpacity}
                  endOpacity={g.endOpacity}
                  color={g.color}
                />
              ))}
            {defs}
          </defs>
          {bordered && (
            <rect
              className="graph-border"
              x={margins.left}
              y={margins.top}
              width={svgDimensions.width - margins.left - margins.right}
              height={svgDimensions.height - margins.top - margins.bottom}
            />
          )}
          {children}
        </svg>
      </section>
    );
  }
}

Chart.propTypes = {
  svgDimensions: PropTypes.object.isRequired,
};

// TODO direction is passed in, but we only respect top to bottom right now.
const Gradient = ({id, direction, startOpacity, endOpacity, color}) => (
  <linearGradient id={id} x1={'0%'} x2={'0%'} y1={'100%'} y2={'0%'}>
    <stop offset={'0%'} stopColor={color} stopOpacity={endOpacity} />
    <stop offset={'100%'} stopColor={color} stopOpacity={startOpacity} />
  </linearGradient>
);
